

// import React from 'react';
// import { Navigate } from 'react-router-dom';

// const ProtectedRoute = ({ children, allowedRole }) => {
//  const savedUser = sessionStorage.getItem("user");
//   const user = savedUser ? JSON.parse(savedUser) : null;

//   // 1. If not logged in, send to Home (where your login modal is)
//   if (!user) {
//     alert("Please login to access this page.");
//     return <Navigate to="/" replace />;
//   }

//   // 2. If role doesn't match (e.g., user trying to enter admin panel)
//   if (allowedRole && user.role !== allowedRole) {
//     alert("Access Denied: Unauthorized Role.");
//     return <Navigate to="/" replace />;
//   }

//   return children;
// };

// export default ProtectedRoute;


import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, allowedRole, allowedAccountType }) => {
  const savedUser = sessionStorage.getItem("user");
  const user = savedUser ? JSON.parse(savedUser) : null;

  // 1. If not logged in, send to Home
  if (!user) {
    alert("Please login to access this page.");
    return <Navigate to="/" replace />;
  }

  // 2. Role check (existing)
  if (allowedRole && user.role !== allowedRole) {
    alert("Access Denied: Unauthorized Role.");
    return <Navigate to="/" replace />;
  }

  // 3. NEW: account_type check
  if (allowedAccountType && user.account_type !== allowedAccountType) {
    alert(`Access Denied: Requires ${allowedAccountType} account.`);
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;